import iconDiscord from '@assets/social-icons/discord-icon.png';
import iconRewardsOverlay from '@assets/overlays/rewards/icons/rewards-icon.png';
import iconRocketGraphicsBundle from '@assets/graphics/icons/rocket-bundle.png';
import iconPracticesInformation from '@assets/tools/icons/participate.png';
import iconAlerts from '@assets/alerts/icons/sj-alert-icon.png';

/** @typedef {object} Category
 * @property {string} name
 * @property {string} pageName
 * @property {string} description
 * @property {string} link
 * @property {string} type
 * @property {string} thumbnail
 */

/**
 *
 * @type {Array<Category>}
 */
export const categories = [
  {
    name: 'Fundraising Overlays',
    pageName: 'Fundraising Overlays',
    description:
      'Track your progress, display poll results, and showcase rewards with these customizable stream overlays',
    link: '/overlays',
    thumbnail: iconRewardsOverlay,
    type: 'overlays',
  },
  {
    name: 'Chatbots',
    description:
      'Use bot commands to keep your community up-to-date on your fundraising progress.',
    link: '/chatbots',
    thumbnail: iconDiscord,
    type: 'chatbots',
  },
  {
    name: 'Graphics and Assets',
    description:
      'Download graphics and assets to enhance your fundraising streams, engage your audience on other platforms, and more',
    link: '/graphics',
    thumbnail: iconRocketGraphicsBundle,
    type: 'graphics',
  },
  {
    name: 'Alerts',
    description:
      'Utilize our donation alerts to enhance your Tiltify fundraising campaign by acknowledging donations to your fundraising stream',
    link: '/overlays/alerts',
    thumbnail: iconAlerts,
    type: 'alerts',
  },
  {
    name: 'Information',
    description:
      'View best practices and guidelines for streaming with PLAY LIVE overlays and more',
    link: '/information',
    thumbnail: iconPracticesInformation,
    type: 'information',
  },
];
